import PropTypes from "prop-types";
import { ICON_SIZES } from "app/constants";
function Twitter154SvgrepoCom1Icon({ size, ...props }) {
	return (
		<svg
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...(size !== undefined && { width: size, height: size })}
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.10595 20.3966C16.0274 20.3966 20.3601 13.9348 20.3601 8.33175C20.3601 8.14781 20.3601 7.96525 20.3475 7.78337C21.1904 7.184 21.9178 6.43982 22.4961 5.58832C21.711 5.9314 20.8765 6.1564 20.0232 6.2556C20.9217 5.72547 21.5945 4.89261 21.9167 3.90986C21.0707 4.40382 20.146 4.75243 19.1814 4.93949C17.5503 3.23233 14.8224 3.14961 13.0874 4.7555C11.9696 5.79095 11.4941 7.33479 11.8415 8.80736C8.37885 8.63582 5.15235 7.02583 2.96496 4.37727C1.82194 6.31486 2.40657 8.79266 4.29902 10.0369C3.61362 10.0172 2.94292 9.83554 2.34359 9.50693V9.56074C2.34464 11.5789 3.78996 13.3167 5.79891 13.7166C5.16494 13.8871 4.49949 13.9119 3.85503 13.7889C4.41867 15.5167 6.03612 16.7002 7.87818 16.7343C6.3531 17.9144 4.46905 18.5552 2.52937 18.5531C2.1872 18.5521 1.84503 18.5325 1.50391 18.4922C3.47402 19.7364 5.76532 20.3966 8.10595 20.3936"
				fill="currentColor"
			/>
		</svg>
	);
}

Twitter154SvgrepoCom1Icon.propTypes = {
	size: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Twitter154SvgrepoCom1Icon;
